var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDealIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 126,
    viewBox: "0 0 164 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5883 16.4873C52.0218 21.6273 55.8674 26.8194 61.2408 26.8194H103.593C108.964 26.8194 112.809 21.6327 111.248 16.4941L107.961 5.67473C106.937 2.30417 103.829 0 100.307 0H64.538C61.018 0 57.9116 2.30078 56.8855 5.66789L53.5883 16.4873ZM104.134 11.0904C105.689 16.2272 101.847 21.4177 96.4802 21.4177H68.387C63.0152 21.4177 59.173 16.2182 60.7365 11.0789C61.7614 7.70997 64.8704 5.40169 68.3918 5.40169H96.4754C100.001 5.40169 103.113 7.71568 104.134 11.0904Z",
    fill: "#3F4659"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19H155C158.866 19 162 22.134 162 26V119C162 122.866 158.866 126 155 126H9C5.134 126 2 122.866 2 119V26C2 22.134 5.134 19 9 19Z",
    fill: "#FF8282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 67.3135H162V74.8582H2V67.3135Z",
    fill: "#FF5858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6363 96.6159H88.1627C89.9964 96.6159 91.4634 95.0764 91.4634 93.2128V73.0916C91.4634 71.201 89.9702 69.6885 88.1627 69.6885H76.6625C74.8288 69.6885 73.3618 71.228 73.3618 73.0916V93.2128C73.3356 95.0764 74.8288 96.6159 76.6363 96.6159Z",
    fill: "#EAEFFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.399 83.2204C80.2433 83.2204 78.4958 81.4187 78.4958 79.1961C78.4958 76.9736 80.2433 75.1719 82.399 75.1719C84.5547 75.1719 86.3022 76.9736 86.3022 79.1961C86.3022 81.4187 84.5547 83.2204 82.399 83.2204Z",
    fill: "#3F4659"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8933 91.0801H86.9048L84.8353 81.249H79.9628L77.8933 91.0801Z",
    fill: "#3F4659"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.967 17.3125H115.668V19.5002H101.967V17.3125Z",
    fill: "#3F4659"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8419 17.3125H62.5425V19.5002H48.8419V17.3125Z",
    fill: "#3F4659"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19H159C161.761 19 164 21.2386 164 24V62C164 64.7614 161.761 67 159 67H5C2.23857 67 0 64.7614 0 62V24C0 21.2386 2.23857 19 5 19Z",
    fill: "#FF8282"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91826 28.9863H159.909C161.282 28.9863 162.384 27.7226 162.384 26.1494C162.384 24.5762 161.282 23.3125 159.909 23.3125H6.91826C5.54584 23.3125 4.44341 24.5762 4.44341 26.1494C4.44341 27.7226 5.56834 28.9863 6.91826 28.9863Z",
    fill: "#FF5858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealIllustration);
export default __webpack_public_path__ + "static/media/deal-illustration.f3c9cc67b8c4cde293ea5ef46da529c8.svg";
export { ForwardRef as ReactComponent };